import { memo, useMemo } from "react";

import { Box, Typography } from "@mui/material";
import {
  Add,
  ArrowLeft,
  ArrowRight,
  ReduceCapacity,
  Remove,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import KsbActionButton from "../../../../2_ksbHub/components/KsbActionButton";

/**
 * =========================================================
 * ✅ ASKOMA ZOOM NAVIGATOR
 * =========================================================
 */
function AskomaZoomNavigator({ zoomLevel, setZoomLevel }) {
  const theme = useTheme();

  const label = useMemo(() => {
    const labels = {
      1: "Übersicht",
      2: "Normal",
      3: "Detail",
      4: "Maximal",
    };

    return labels[zoomLevel] ?? `Zoom ${zoomLevel}`;
  }, [zoomLevel]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0,
      }}
    >
      <KsbActionButton
        label={<Remove />}
        icon={<Remove />}
        onClick={() => setZoomLevel((prev) => Math.max(1, prev - 1))}
        sx={{
          bgcolor: theme.palette.primary.main,
          "&:hover": {
            bgcolor: theme.palette.primary.dark,
          },
        }}
      />

      <Typography
        sx={{
          minWidth: 100,
          textAlign: "center",
          fontWeight: 400,
        }}
      >
        {label}
      </Typography>

      <KsbActionButton
        label={<Add />}
        icon={<Add />}
        onClick={() => setZoomLevel((prev) => Math.min(4, prev + 1))}
        sx={{
          bgcolor: theme.palette.primary.main,
          "&:hover": {
            bgcolor: theme.palette.primary.dark,
          },
        }}
      />
    </Box>
  );
}

export default memo(AskomaZoomNavigator);
